
import Vue from 'vue'

export default Vue.extend({
  props: {
    pagination: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
})
